export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_FAILURE = "GET_USER_PROFILE_FAILURE";

export const VERIFY_USER_AUTH = "VERIFY_USER_AUTH";
export const VERIFY_USER_AUTH_SUCCESS = "VERIFY_USER_AUTH_SUCCESS";
export const VERIFY_USER_AUTH_FAILURE = "VERIFY_USER_AUTH_FAILURE";
